export default {
  namespaced: true,
  state: {
    loading: false
  },
  mutations: {
    startLoading (state) {
      state.loading = true
    },
    stopLoading (state) {
      state.loading = false
    }
  },
  getters: {
    loading: state => state.loading
  }
}
